import Vue, { FunctionalComponentOptions, RenderContext } from 'vue'

export const TableHeader = <FunctionalComponentOptions> {
    name: 'table-header',
    functional: true,

    render(h, ctx) {
        return (
            h('div', mergeClass(ctx, false, 'list-header-container'), [
                h('div', { class: 'list-header' }, [
                    h('div', { class: 'main-wrapper' }, [
                        h('div', { class: 'list-item' }, [ctx.slots()['default']])
                    ])
                ])
            ])
        )
    }
}

export const TableCell = <FunctionalComponentOptions> {
    name: 'table-cell',
    functional: true,

    render(h, ctx) {
        return (
            h('div', mergeClass(ctx, ctx.data.attrs && ctx.data.attrs['stretch'] != null, 'list-cell'), [
                h('div', { class: 'content' }, ctx.slots()['default'])
            ])
        )
    }
}

export const TableLabel = <FunctionalComponentOptions> {
    name: 'table-label',
    functional: true,

    render(h, ctx) {
        return (
            h('div', mergeClass(ctx, ctx.data.attrs && ctx.data.attrs['stretch'] != null, 'list-cell'), [
                h('div', { class: 'content' }, [
                    h('div', { class: 'label' }, ctx.slots()['default'])
                ])
            ])
        )
    }
}

function mergeClass(ctx: RenderContext<Record<string,any>>, isStretch: boolean, staticClass: string) {
    if (ctx.data.staticClass) {
        staticClass = ctx.data.staticClass + ' ' + staticClass;
    }
    if (isStretch) {
        staticClass += " list-cell--stretch";
    }
    return { staticClass: staticClass, class: ctx.data.class };
}